import { CONTACTS_IMPORT_API } from 'modules/contacts/contacts-import/api/contacts-import-api'
import {
  ContactsImportFilterInterface,
  ContactsLastImportsApiInterface,
} from 'modules/contacts/contacts-import/types/contacts-import-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import useSWR from 'swr'

export interface ContactPageSwrInterface extends SwrPaginationInterface {
  filter: ContactsImportFilterInterface
}

export function useLastContactsImports({ limit, pagination, filter }: ContactPageSwrInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ContactsLastImportsApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${filter.date[0] ? `&filter[dateSince]=${filter.date[0]}` : ''}${
    filter.date[1] ? `&filter[dateTill]=${filter.date[1]}` : ''
  }`

  const {
    data: lastContactsImports,
    mutate: mutateLastContactsImports,
    isValidating: isLastContactsImportsValidating,
  } = useSWR(() => {
    if (user && limit) {
      if (pagination.startFromId) {
        return `${CONTACTS_IMPORT_API}?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}${filterApi}`
      } else {
        return `${CONTACTS_IMPORT_API}?pagination[limit]=${limit}${filterApi}`
      }
    } else {
      return null
    }
  }, fetcher)

  return { lastContactsImports, isLastContactsImportsValidating, mutateLastContactsImports }
}
